module.exports = __webpack_public_path__ + "static/img/bottom-button-3-down.584f2b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-3-down.png
// module id = dM4t
// module chunks = 1